import axios from 'axios'

const editAdminInfo = async (userData, userId) => {
  console.log('hjer')
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/updateMyProfile/${userId}`,
      userData,
      {
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export default editAdminInfo
